module.exports = __webpack_public_path__ + "img/2.01.7dae3a35.jpg";